export default __webpack_public_path__ + "static/media/Vertical_AHU_1_unselected.f21daf72.svg";